import { Stack } from '@mui/material'
import { BreadcrumbItem, Breadcrumbs, PageTemplate } from 'ComponentLibrary'
import { ReactNode } from 'react'
import { useLocation } from 'react-router-dom'

export const ClientPortalPageWithSidebarTemplate = ({
    title,
    breadCrumbs,
    children,
    sidebarComponent,
    isPersisting = false,
    withMargin,
    fullWidth = true,
    withMaxWidth,
}: {
    children: ReactNode
    title?: string
    breadCrumbs?: BreadcrumbItem[]
    sidebarComponent: ReactNode
    isPersisting?: boolean
    withMargin?: boolean
    fullWidth?: boolean
    withMaxWidth?: boolean
}) => {
    const { pathname } = useLocation()
    return (
        <Stack direction="row" width="100%">
            {sidebarComponent}
            <PageTemplate
                headline={title ? { title, isPersisting } : undefined}
                fullWidth={fullWidth}
                withMargin={withMargin}
                alignLeft
                withFooter
                withBottomSpace
                withMaxWidth={withMaxWidth}
                pageTopAdornment={breadCrumbs ? <Breadcrumbs items={breadCrumbs} currentLocation={pathname} /> : undefined}
            >
                {children}
            </PageTemplate>
        </Stack>
    )
}
